<div class="group inner-page-wrapper flex w-full items-center justify-between py-8 lg:min-h-64 lg:justify-center">
    <span class="text-left font-headline text-16 leading-27 text-white">
        <ng-content />
    </span>
    <i class="animated-arrow-right ml-12 shrink-0 text-white"></i>
</div>
